import { validationFactory } from '../validation/validation';
/**
 * Validator that requires the length of the property's value to be greater or equal to the provided number
 *
 * @param minLength Minimum possible length
 */
export var minLength = validationFactory('minLength');
//# sourceMappingURL=min-length.js.map